let store = require("../store");
let actions = require("../actions");

let Blip = mc.widgets.Blip;
let IconButton = mc.widgets.IconButton;

class SubjectMessagesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { studyId, subjectId } = this.props;
    let state = store.getState();
    let subject = state.subjects[subjectId];
    let study = state.study[studyId];
    let messages = state.messages[subjectId] || [];

    return {
      subject,
      study,
      messages,
      // input: "",
      submitting: false
    };
  }

  componentDidMount() {
    let { studyId, subjectId } = this.props;

    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadStudy(studyId);
    actions.loadSubject(studyId, subjectId);
    actions.loadMessages(studyId, subjectId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  setInput(evt) {
    this.setState({
      input: evt.target.value
    });
  }

  loadMessages() {
    let { studyId, subjectId } = this.props;

    actions.loadMessages(studyId, subjectId);
  }

  submitMessage() {
    let { studyId, subjectId } = this.props;
    let { input } = this.state;

    this.setState({
      submitting: true
    });

    actions.postMessage(studyId, subjectId, input).then((function (payload) {
      if (payload.errors.length) {
        mc.ui.alert("Oops! There was a problem sending your message.", { level: "error" });

        this.setState({
          submitting: false
        });
      }
      else {
        this.setState({
          submitting: false,
          input: ""
        });
      }
    }).bind(this)).then((function () {
      this.loadMessages();
    }).bind(this));
  }

  markAsRead(messageId) {
    let { studyId, subjectId } = this.props;

    actions.readMessages(studyId, subjectId, [messageId]);
  }

  zoomImage(image) {
    let opts = {
      width: "860px",
      maxWidth: "90%",
      height: "90%"
    };

    mc.ui.modal(<img src={image.href} width="775"/>, opts);
  }

  render() {
    let { study, subject, messages, input = "", submitting } = this.state;

    let { GREEN, LIGHT_GRAY } = mc.ui.colors;

    if (!subject) {
      return null;
    }

    let disabled = !study || study.lifecycleState !== "IN_PROGRESS" || subject.isHidden;

    return (
      <div className="rc-subject-messages-view">
        <h1>
          <a href={mc.router.resolve("SUBJECT_DETAIL_VIEW", this.props)}>
            {subject.displayName || "..."}
          </a>
          {" › " + tx("link_messages")}
        </h1>
        <ul>
          {messages.map((function (message) {
            return (
              <li
                key={message.id}
                data-principal={message.author.principalType}
                data-created-ts={message.createdTs}
                data-is-read={message.isRead}>
                <div>
                  <p>
                    <b>{message.author.displayName}:</b> {message.body}
                  </p>
                  {message.image && (
                    <img src={message.image.href} onClick={this.zoomImage.bind(this, message.image)}/>
                  )}
                  <small>{mc.format.datetime(message.createdTs)}</small>
                  {message.author.principalType === "SUBJECT" && (
                    <Blip color={message.isRead ? LIGHT_GRAY : GREEN}>
                      {message.isRead ? tx("is_read") : (
                        <button onClick={this.markAsRead.bind(this, message.id)}>
                          {tx("mark_as_read")}
                        </button>
                      )}
                    </Blip>
                  )}
                </div>
              </li>
            );
          }).bind(this))}
          <li data-principal="USER">
            <div className="rc-subject-messages-view-input">
              <textarea
                rows="5"
                value={input}
                onChange={this.setInput.bind(this)}
                disabled={disabled || submitting}/>
              <br/>
              <button
                className="mc-button mc-save"
                onClick={this.submitMessage.bind(this)}
                disabled={disabled || submitting || input.trim().length === 0}>
                  {tx("send_message")}
              </button>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

module.exports = SubjectMessagesView;